import React, { useEffect, useState } from 'react';
import { getSettings, TenantSettings } from '../services/settingsService';
import { Calendar, AlertCircle, Clock } from 'lucide-react';
import { useFirebase } from '../contexts/FirebaseContext';

export const PayrollDueReminder: React.FC = () => {
    const { tenantId } = useFirebase();
    const [settings, setSettings] = useState<TenantSettings | null>(null);

    useEffect(() => {
        if (tenantId) {
            getSettings(tenantId).then(setSettings);
        }
    }, [tenantId]);

    if (!settings || !settings.payCycle || !settings.payDayDue) return null;

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const targetDayIndex = days.indexOf(settings.payDayDue);
    const today = new Date();
    const todayDayIndex = today.getDay();
    let diff = targetDayIndex - todayDayIndex;
    if (diff <= 0) diff += 7; 

    const urgency = diff <= 2 ? 'urgent' : diff <= 5 ? 'warning' : 'normal';

    const getStyles = () => {
        switch (urgency) {
            case 'urgent': return "bg-red-50 border-red-100 text-red-900";
            case 'warning': return "bg-amber-50 border-amber-100 text-amber-900";
            default: return "bg-indigo-50 border-indigo-100 text-indigo-900";
        }
    };

    const getIcon = () => {
        switch (urgency) {
            case 'urgent': return <AlertCircle size={18} />;
            case 'warning': return <Clock size={18} />;
            default: return <Calendar size={18} />;
        }
    };

    return (
        <div className={`p-4 border rounded-xl flex items-center gap-4 mb-6 ${getStyles()}`}>
            <div className="p-2 bg-white rounded-lg shadow-sm">
                {getIcon()}
            </div>
            <div>
                <h4 className="text-xs font-bold uppercase tracking-widest opacity-80">Payroll Due</h4>
                <p className="text-[10px] font-medium mt-0.5">
                    {settings.payCycle} cycle · Due {settings.payDayDue} ({diff} day{diff !== 1 ? 's' : ''})
                </p>
            </div>
        </div>
    );
};
